import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, role, loading } = useContext(AuthContext);

  if (loading) return <div>Loading...</div>; // یا spinner

  if (!user || !role) return <Navigate to="/authentication/sign-in" replace />;

  if (!allowedRoles.includes(role)) return <Navigate to="/not-found" replace />;

  return children;
};

export default ProtectedRoute;
